import { render, staticRenderFns } from "./Editsegments.vue?vue&type=template&id=707d1970&scoped=true&"
import script from "./Editsegments.vue?vue&type=script&lang=js&"
export * from "./Editsegments.vue?vue&type=script&lang=js&"
import style0 from "./Editsegments.vue?vue&type=style&index=0&id=707d1970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d1970",
  null
  
)

export default component.exports